import React from 'react';
import './platform-card.css';
import CTAButton from '../cta-button/CTAButton';
import RightArrowSimple1 from '../elements-icons/RightArrowSimple1';

const PlatformCard = (props) => {
  const { card } = props;
  
  return (
    <div className={`card-meet-platform text-lt ${card.cardClass}`}>
      <div className="wrapper-meet-platform">
        <div className={card.iconClass}>
          {card.icon}
        </div>
        <h3 className='title-sub-2'>
          {card.title}
        </h3>
        <p className="meet-platform-content paragraph-lt-sub">
          {card.content}
        </p>
        <div className='card-meet-platform-link'>
          <CTAButton url={card.url} icon={<RightArrowSimple1 svgClass='icon-sm' pathClass='icon-wht'/>} className='btn-hollow-sm text-lt bg-clear' content='Learn More'/>
        </div>
      </div>
    </div>
    );
}

export default PlatformCard;